import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CHAT_STRINGS_PT, ChatStrings } from '../../chat.strings';
import { ChatVisitFormParams } from '../../chat.model';
import { formatWhen } from '../../chat.format';

/**
 * `kind: 'visit_form'` (7.2): a ficha de visita virtual enviada ao cliente.
 * Pendente ou respondida (com o interesse de 1 a 5 quando existe); "Abrir
 * ficha" leva à página pública e, para o staff, "Copiar link" serve o tablet
 * na visita ou qualquer outro canal.
 */
@Component({
  selector: 'chat-visit-form-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './chat-visit-form-card.component.html',
  styleUrls: ['./chat-visit-form-card.component.css']
})
export class ChatVisitFormCardComponent implements OnChanges {
  @Input() params: Partial<ChatVisitFormParams> = {};
  @Input() canManage = false;
  @Input() strings: ChatStrings = CHAT_STRINGS_PT;
  @Output() copy = new EventEmitter<void>();

  answered = false;
  when = '';
  stars: boolean[] = [];

  ngOnChanges(): void {
    const p = this.params || {};
    this.answered = p.status === 'answered';
    this.when = formatWhen(p.startAt);
    const interest = Number(p.interest || 0);
    this.stars = interest > 0 ? [1, 2, 3, 4, 5].map(i => i <= interest) : [];
  }
}
